import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import useQlikApp from 'hooks/useQlikApp';

const useStyles = makeStyles(() => ({
  checkboxFilter: {
    '& .MuiCheckbox-root': {
      padding: '3px !important',
    },
  },
  formControl: {
    minWidth: 120,
    marginLeft: 20,
  },
  selectLabel: {
    color: '#FFFFFF !important',
  },
  select: {
    backgroundColor: '#404040',
    borderTopLeftRadius: '0 !important',
    borderTopRightRadius: '0 !important',
    '& > svg': {
      fill: '#FFFFFF !important',
    },
  },
  selectS: {
    backgroundColor: '#28a745 !important',
    color: '#FFFFFF !important',
  },
}));

const CheckboxFilter = React.forwardRef(({ parentCallback, medalsState, handleMedalsStateChange }, ref) => {
  const qlikApp = useQlikApp();

  const { Gold, Silver, Bronze } = medalsState;

  const handleChange = (event) => {
    handleMedalsStateChange(event.target.name, event.target.checked);
  };

  useEffect(async () => {
    if (!qlikApp) return;

    const appObj = await qlikApp.getObject(ref.current.id);
    const _values = [];
    const _valuesToPass = [];

    Object.entries(medalsState).forEach((entry) => {
      const [key, value] = entry;
      if (value) {
        _values.push(`Sum({<[Team]=>} [${key}])`);
        _valuesToPass.push(key);
      }
    });

    const value = _values.join(' + ');

    parentCallback(_valuesToPass);

    await appObj.applyPatches([
      {
        qPath: '/qHyperCubeDef/qMeasures/0/qDef/qDef',
        qOp: 'replace',
        qValue: `"${value || 'Sum({<[Team]=>} [Total])'}"`,
      },
    ], true);
  }, [medalsState]);

  const classes = useStyles();
  return (
    <div className={classes.checkboxFilter}>
      <FormControl required component="fieldset" className={classes.formControl}>
        <FormGroup row>
          <FormControlLabel
            control={<Checkbox checked={Gold} onChange={handleChange} name="Gold" />}
            label="🥇"
          />
          <FormControlLabel
            control={<Checkbox checked={Silver} onChange={handleChange} name="Silver" />}
            label="🥈"
          />
          <FormControlLabel
            control={<Checkbox checked={Bronze} onChange={handleChange} name="Bronze" />}
            label="🥉"
          />
        </FormGroup>
      </FormControl>
    </div>
  );
});

CheckboxFilter.propTypes = {
  parentCallback: PropTypes.func,
  medalsState: PropTypes.object.isRequired,
  handleMedalsStateChange: PropTypes.func.isRequired,
};

CheckboxFilter.defaultProps = {
  parentCallback: () => {},
};

export default CheckboxFilter;
